import { API } from "../../api";
import Cookie from "universal-cookie";
async function add_user_address(data) {
    const cookie = new Cookie();
    const userToken = cookie.get("user_token");
    return await new API().apiPost({
        baseUrl: process.env.LETS_TRADE_USER_URL ?? "",
        endpoint: `v2/add/address`, //
        content: data,
        authorization: userToken,
    });
}
export { 
// IAddUserAddressRequest,
add_user_address, };
